import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';

import { setFindLatLatLng, resetFindLatLng } from '../../features/map/mapSlice';
import { removeMarkerDetailView, removeZoneDetailView } from '../../features/places/placesSlice';

const FindLatLng = ({ findLatLngOpen, handleFindLatLngClose }) => {
    const dispatch = useDispatch();

    const [lat, setLat] = useState(0);
    const [lng, setLng] = useState(0);


    const handleSubmit = () => {
        if (lat && lng) {
            dispatch(removeZoneDetailView());
            dispatch(removeMarkerDetailView());
            dispatch(setFindLatLatLng({ lat, lng }));
        }
        handleFindLatLngClose();
    }

    const handleClose = () => {
        dispatch(resetFindLatLng());
        handleFindLatLngClose();
    }

    return (
        <Dialog open={findLatLngOpen} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title"><b>Find Lat/Lng Point</b></DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Enter the latitude and longitude of the location you want to find.
                </DialogContentText>
                <form>
                    <TextField
                        variant="standard"
                        autoFocus
                        id="lat"
                        label="Latitude"
                        type="number"
                        value={lat}
                        onChange={(e) => setLat(e.target.value)}
                    />
                    <br />
                    <br />
                    <Typography variant="body1">Reading Date & Time</Typography>
                    <TextField
                        variant="standard"
                        id="lng"
                        type="number"
                        label="Longitude"
                        value={lng}
                        onChange={(e) => setLng(e.target.value)}
                    />
                </form>

            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleSubmit} color="primary" disabled={!lat || !lng}>
                    Find
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default FindLatLng;
